import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "./Header";
import {
  FormStep,
  ApplicationState,
  Step
} from "../../store/application/applicationState";
import { RootState } from "../../store";
import ApplicationContent from "../applicationContent";
import { trackEvent } from "../../util/gtm";

const StepCallback: React.FunctionComponent = props => {
  const state = useSelector<RootState, ApplicationState>(
    x => x.applicationState
  );
    const dispatch = useDispatch();
    (window as any).fbq('track', 'AddToCart')
    const GaEvent = () => {
        let userId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1).replace("w-", "");
        trackEvent(
            "ESkat",
            "Bruger " + "refId:" + userId + " gået til Eskat",
            "ESkat",
            userId

        )

    } 
    var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + "?step=13";
    window.history.pushState({ path: stepQuery }, '', stepQuery)
  return (
    <div>
          <Header formStep={FormStep.Approve} step={Step.Callback} />
      <ApplicationContent>
        {state.application.sending && (
          <img src="../images/spinner.gif" className="center" />
        )}

        {state.application.error && (
          <div>
            <h2>Der er sket en uventet fejl</h2>
            <p>
              Der opstod en fejl under behandlingen af din ansøgning, prøv
              venligst igen.
            </p>
            <p>
              Hvis problemet fortsætter beder vi dig kontakte vores support.
            </p>
          </div>
        )}

        {state.application.data && (
          <div>
            <p>
              Du skal nu videre til skat.dk og give samtykke til, at
              Skatteforvaltningen må videregive dine oplysninger til Basisbank
              A/S
            </p>
            <a
                          className="next whiteButton buttonMarkup btn btn-secondary"
                          href={state.application.data.consentUrl}
                          onClick={GaEvent}
            >
              Gå til skat
            </a>
          </div>
        )}
      </ApplicationContent>
    </div>
  );
};

export default StepCallback;

//hasResponded() {
//    {/*if (this.props.response === null)
//            return <img src="../images/spinner.gif" className="center" />;*/}

//    return (
//        <div className="text-center">
//            {/*<a href={this.props.response.digitalSigningPage} target="_blank">
//                    Klik her for at underskrive på SKAT.dk
//                </a>*/}
//        </div>
//    );
//}

//render() {

//    return (

//        );
//}
